import { useState } from 'react';
import '../css/ArtworkCredit.css';

function ArtworkCredit({ children }) {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`art-credit${isOpen ? ' is-open' : ''}`}>
            <button
                className="art-credit-trigger"
                type="button"
                aria-expanded={isOpen}
                aria-label="Learn about Luminism"
                onClick={() => setIsOpen((open) => !open)}
                onKeyDown={(event) => {
                    if (event.key === 'Escape') {
                        setIsOpen(false);
                        event.currentTarget.blur();
                    }
                }}
            >
                {children}
            </button>
            <aside className="luminism-card" aria-label="About Luminism">
                Luminism is a 19th-century American landscape style tied to the Hudson River School,
                known for clear light, calm scenes, and wide horizons.
            </aside>
        </div>
    );
}

export default ArtworkCredit;
